module.exports = __webpack_public_path__ + "static/media/security-flag.055a4a93.png";